import Rest from '../services/rest'
import {store} from '../store/store'

/**
 * @typedef {CotacaoService}
 */
export default class CotacaoService{

    constructor() {
        this.resource = "/cotacao"

        this.http = Rest.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    get_all(){       
        return this.http.get(`/platforms`);
    }

    get_one(item){
        var parameters = new URLSearchParams(item);
       
        parameters = parameters.toString();
        if(parameters){
            parameters = "?"+parameters;
        }
        return this.http.get(`/cotacoes/${parameters}`)    
    }

    save_cotacao(params){
        return this.http.post('/save', params)
    }

    apply_cotacao(params){
        return this.http.post('/apply', params)
    }


}